import { Icon, Label, Link, Stack, Text } from "@fluentui/react";
import { AppLinkToExternal } from "global/Application";
import { EHideReason } from "global/Visibility/EHideReason";
import {
    bcbs_config_attribute as IXrmTypes_bcbs_config_attribute,
    bcbs_config_masterattribute as IXrmTypes_bcbs_config_masterattribute
} from 'model/CRM';
import {
    IFlexibleField as FAM_IFlexibleField,
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig
} from 'model/FlexibleAttributeModel';
import { useMemo } from "react";
import InformationCallout from "./InformationCallout";
import { getOptionsetItems } from "./OptionsetControl";
import { useDispatch } from "react-redux";
import { setStatusHighlightField } from "global/Reducer/statusSlice";

interface IControlDebug {
    masterAttribute?: IXrmTypes_bcbs_config_masterattribute;
    configAttribute?: IXrmTypes_bcbs_config_attribute;
    field?: FAM_IFlexibleField;
    config: FAM_IGroupConfigurationConfig,
}


export const ControlDebug = (props: IControlDebug) => {

    const dispatch = useDispatch();
    const options = useMemo(() => {
        if (props.field) {
            const { options, optionLookup } = getOptionsetItems(props.config, props.field.configRef, props);
            return options;
        }

        console.warn('Option set for the field not found!', props.field);

        return null;
    }, []);


    //@ts-ignore
    const visibility = props.configAttribute.visibility;

    return <div style={{ position: 'relative' }}>
        <div
            style={{ position: 'absolute', left: '-24px', top: '6px' }}
        >
            {/* {`${props.configAttribute?.bcbs_sortorder}`} */}

            <InformationCallout>
                <Stack>

                    {props.field?.id &&
                        <div>
                            <Text>
                                📝 Id: {props.field?.id}
                                <Icon
                                    iconName="Copy"
                                    styles={{ root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer' } }}
                                    onClick={() => navigator.clipboard.writeText(props.field?.id!)}
                                />
                            </Text>
                        </div>
                    }
                    <Link
                        href={AppLinkToExternal({ type: 'bcbs_config_attribute', id: props.configAttribute?.bcbs_config_attributeid! })}
                        target={"_blank"}
                        rel={"noopener noreferrer"}
                    >
                        ⚙️ Attribute
                        {props.configAttribute?.bcbs_config_attributeid &&
                            <Icon
                                iconName="Copy"
                                styles={{ root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer' } }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    navigator.clipboard.writeText(props.configAttribute?.bcbs_config_attributeid!)
                                }}
                            />
                        }
                    </Link>

                    <Link
                        href={AppLinkToExternal({ type: 'bcbs_config_masterattribute', id: props.masterAttribute?.bcbs_config_masterattributeid! })}
                        target={"_blank"}
                        rel={"noopener noreferrer"}
                    >
                        ⚙️ Master Attribute
                        {props.configAttribute?.bcbs_config_attributeid &&
                            <Icon
                                iconName="Copy"
                                styles={{ root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer' } }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    navigator.clipboard.writeText(props.masterAttribute?.bcbs_config_masterattributeid!)
                                }}
                            />
                        }
                    </Link>


                    {
                        <Link
                            onClick={() => navigator.clipboard.writeText(
                                JSON.stringify({
                                    masterAttribute: props.masterAttribute,
                                    attribute: props.configAttribute
                                }))
                            }
                            target={"_blank"}
                            rel={"noopener noreferrer"}
                        >
                            ⚙️ Copy as JSON
                            <Icon
                                iconName="Copy"
                                styles={{ root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer' } }}

                            />
                        </Link>
                    }

                    {(options?.length ?? 0) > 0 &&
                        <Link
                            onClick={() => navigator.clipboard.writeText(JSON.stringify(options))}
                            target={"_blank"}
                            rel={"noopener noreferrer"}
                        >
                            ⚙️ Copy Options as JSON
                            <Icon
                                iconName="Copy"
                                styles={{ root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer' } }}

                            />
                        </Link>
                    }

                    {
                        <Link
                            target={"_blank"}
                            rel={"noopener noreferrer"}
                            onClick={() => {
                                dispatch(setStatusHighlightField(props.configAttribute?.bcbs_config_attributeid!))
                            }}
                        >
                            🎯 Highlight
                        </Link>
                    }

                    {props.masterAttribute?.bcbs_logicalname &&
                        <div>
                            <Text>
                                📝 bcbs_logicalname: {props.masterAttribute?.bcbs_logicalname}
                                <Icon
                                    iconName="Copy"
                                    styles={{ root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer' } }}
                                    onClick={() => navigator.clipboard.writeText(props.masterAttribute!.bcbs_logicalname!)}
                                />
                            </Text>
                        </div>
                    }

                    {(props.configAttribute?.bcbs_parentattributevalue || props.configAttribute?._bcbs_parentmasterattributeid_value) &&
                        <>
                            <Link
                                href={AppLinkToExternal({ type: 'bcbs_config_masterattribute', id: props.configAttribute?._bcbs_parentmasterattributeid_value! })}
                                target={"_blank"}
                                rel={"noopener noreferrer"}
                            >
                                👁‍🗨 Parent Attribute: {props.config.cache.map_bcbs_config_masterattribute[props.configAttribute?._bcbs_parentmasterattributeid_value!]?.bcbs_name}
                            </Link>
                            <Text>
                                👁‍🗨 Parent Value:  {props.configAttribute?.bcbs_parentattributevalue}
                            </Text>
                        </>
                    }

                    <div>
                        <div>
                            <Text>
                                🔑 Visibility Keys:  {Object.keys(visibility).join(' - ')}
                            </Text>
                        </div>

                    </div>

                    {props.field?.visibility &&
                        ControlDebugRenderVisibility(props.field?.visibility)
                    }

                </Stack>
            </InformationCallout>
        </div>
    </div >
}

export default ControlDebug;


export const ControlDebugRenderVisibility = (visibility: EHideReason) => {
    return <Stack>
        <Label>Visibility:</Label>
        <div>
            {(visibility & EHideReason.EffectiveDate) > 0 ? "🔴" : "🟢"} <Text>Effective Date</Text>
        </div>
        <div>
            {(visibility & EHideReason.ExpirationDate) > 0 ? "🔴" : "🟢"} <Text>Expiration Date</Text>
        </div>
        <div>
            {(visibility & EHideReason.erisa) > 0 ? "🔴" : "🟢"} <Text>Erisa</Text>
        </div>
        <div>
            {(visibility & EHideReason.fundingType) > 0 ? "🔴" : "🟢"} <Text>Funding Type</Text>
        </div>
        <div>
            {(visibility & EHideReason.grandFathered) > 0 ? "🔴" : "🟢"} <Text>Grand Fathered</Text>
        </div>
        <div>
            {(visibility & EHideReason.lineOfBusiness) > 0 ? "🔴" : "🟢"} <Text>Line Of Business</Text>
        </div>
        <div>
            {(visibility & EHideReason.ParentVisibility) > 0 ? "🔴" : "🟢"} <Text>Parent Visibility</Text>
        </div>
        <div>
            {(visibility & EHideReason.ParentVisibilityCascade) > 0 ? "🔴" : "🟢"} <Text>Parent Visibility Cascade</Text>
        </div>
        <div>
            {(visibility & EHideReason.Cancellation) > 0 ? "🔴" : "🟢"} <Text>Cancellation</Text>
        </div>
    </Stack>;
}
